/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListRemoteSessionIssuersResult,
  ListRemoteSessionIssuersResult$inboundSchema,
} from "../components/listremotesessionissuersresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListRemoteSessionIssuersSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListRemoteSessionIssuersSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListRemoteSessionIssuersSecurity = {
  option1?: ListRemoteSessionIssuersSecurityOption1 | undefined;
  option2?: ListRemoteSessionIssuersSecurityOption2 | undefined;
};

/**
 * Only issuers from one tier: the project's own (project), inherited from its organization (organization), or from the platform catalog (platform). Omitted lists all three.
 */
export const ListRemoteSessionIssuersQueryParamTier = {
  Project: "project",
  Organization: "organization",
  Platform: "platform",
} as const;
/**
 * Only issuers from one tier: the project's own (project), inherited from its organization (organization), or from the platform catalog (platform). Omitted lists all three.
 */
export type ListRemoteSessionIssuersQueryParamTier = ClosedEnum<
  typeof ListRemoteSessionIssuersQueryParamTier
>;

export type ListRemoteSessionIssuersRequest = {
  /**
   * Pagination cursor.
   */
  cursor?: string | undefined;
  /**
   * Page size (default 50, max 100).
   */
  limit?: number | undefined;
  /**
   * Only issuers whose name, slug or issuer URL contains this text, ignoring case.
   */
  search?: string | undefined;
  /**
   * Only issuers that could sign users in to an upstream at this host (e.g. mcp.linear.app): those whose issuer URL host equals it or is one of its parent domains (linear.app). Host only, optionally with a port; no scheme or path.
   */
  upstreamHost?: string | undefined;
  /**
   * Only issuers from one tier: the project's own (project), inherited from its organization (organization), or from the platform catalog (platform). Omitted lists all three.
   */
  tier?: ListRemoteSessionIssuersQueryParamTier | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type ListRemoteSessionIssuersResponse = {
  result: ListRemoteSessionIssuersResult;
};

/** @internal */
export type ListRemoteSessionIssuersSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListRemoteSessionIssuersSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListRemoteSessionIssuersSecurityOption1$Outbound,
    ListRemoteSessionIssuersSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listRemoteSessionIssuersSecurityOption1ToJSON(
  listRemoteSessionIssuersSecurityOption1:
    ListRemoteSessionIssuersSecurityOption1,
): string {
  return JSON.stringify(
    ListRemoteSessionIssuersSecurityOption1$outboundSchema.parse(
      listRemoteSessionIssuersSecurityOption1,
    ),
  );
}

/** @internal */
export type ListRemoteSessionIssuersSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListRemoteSessionIssuersSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListRemoteSessionIssuersSecurityOption2$Outbound,
    ListRemoteSessionIssuersSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listRemoteSessionIssuersSecurityOption2ToJSON(
  listRemoteSessionIssuersSecurityOption2:
    ListRemoteSessionIssuersSecurityOption2,
): string {
  return JSON.stringify(
    ListRemoteSessionIssuersSecurityOption2$outboundSchema.parse(
      listRemoteSessionIssuersSecurityOption2,
    ),
  );
}

/** @internal */
export type ListRemoteSessionIssuersSecurity$Outbound = {
  Option1?: ListRemoteSessionIssuersSecurityOption1$Outbound | undefined;
  Option2?: ListRemoteSessionIssuersSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListRemoteSessionIssuersSecurity$outboundSchema: z.ZodMiniType<
  ListRemoteSessionIssuersSecurity$Outbound,
  ListRemoteSessionIssuersSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListRemoteSessionIssuersSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListRemoteSessionIssuersSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listRemoteSessionIssuersSecurityToJSON(
  listRemoteSessionIssuersSecurity: ListRemoteSessionIssuersSecurity,
): string {
  return JSON.stringify(
    ListRemoteSessionIssuersSecurity$outboundSchema.parse(
      listRemoteSessionIssuersSecurity,
    ),
  );
}

/** @internal */
export const ListRemoteSessionIssuersQueryParamTier$outboundSchema:
  z.ZodMiniEnum<typeof ListRemoteSessionIssuersQueryParamTier> = z.enum(
    ListRemoteSessionIssuersQueryParamTier,
  );

/** @internal */
export type ListRemoteSessionIssuersRequest$Outbound = {
  cursor?: string | undefined;
  limit?: number | undefined;
  search?: string | undefined;
  upstream_host?: string | undefined;
  tier?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListRemoteSessionIssuersRequest$outboundSchema: z.ZodMiniType<
  ListRemoteSessionIssuersRequest$Outbound,
  ListRemoteSessionIssuersRequest
> = z.pipe(
  z.object({
    cursor: z.optional(z.string()),
    limit: z.optional(z.int()),
    search: z.optional(z.string()),
    upstreamHost: z.optional(z.string()),
    tier: z.optional(ListRemoteSessionIssuersQueryParamTier$outboundSchema),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      upstreamHost: "upstream_host",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listRemoteSessionIssuersRequestToJSON(
  listRemoteSessionIssuersRequest: ListRemoteSessionIssuersRequest,
): string {
  return JSON.stringify(
    ListRemoteSessionIssuersRequest$outboundSchema.parse(
      listRemoteSessionIssuersRequest,
    ),
  );
}

/** @internal */
export const ListRemoteSessionIssuersResponse$inboundSchema: z.ZodMiniType<
  ListRemoteSessionIssuersResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListRemoteSessionIssuersResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listRemoteSessionIssuersResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListRemoteSessionIssuersResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListRemoteSessionIssuersResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRemoteSessionIssuersResponse' from JSON`,
  );
}
